import React, { Component } from 'react';

class MegaMenuMobile extends Component {
     constructor() {
          super();
          this.state = {
               activeIndex: null, // কোন প্যানেলটি ওপেন তা ট্র্যাক করে
          };
     }

     // মেনু এবং সাবমেনুর তথ্য সংরক্ষণ
     menuData = [
          {
               title: "Men's Clothing",
               icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZo2k_dbJ22_eNBTVL1wpxEis4KkLnqyWofcIcgw1YTeGrCcEw0Zi4QhG_jBSA3t-lfKc&usqp=CAU",
               subMenu: ["Mans Tshirt 1", "Mans Tshirt 2"]
          },
          {
               title: "Women's Clothing",
               icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZo2k_dbJ22_eNBTVL1wpxEis4KkLnqyWofcIcgw1YTeGrCcEw0Zi4QhG_jBSA3t-lfKc&usqp=CAU",
               subMenu: ["Womens Skirt", "Womens Saree"]
          }
          ,
          {
               title: "Kids' Clothing",
               icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZo2k_dbJ22_eNBTVL1wpxEis4KkLnqyWofcIcgw1YTeGrCcEw0Zi4QhG_jBSA3t-lfKc&usqp=CAU",
               subMenu: ["Kids Tshirt", "Kids Shorts"]
          }
          ,
          {
               title: "Kids' Clothing",
               icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZo2k_dbJ22_eNBTVL1wpxEis4KkLnqyWofcIcgw1YTeGrCcEw0Zi4QhG_jBSA3t-lfKc&usqp=CAU",
               subMenu: ["Kids Tshirt", "Kids Shorts"]
          }
          ,
          {
               title: "Kids' Clothing",
               icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZo2k_dbJ22_eNBTVL1wpxEis4KkLnqyWofcIcgw1YTeGrCcEw0Zi4QhG_jBSA3t-lfKc&usqp=CAU",
               subMenu: ["Kids Tshirt", "Kids Shorts"]
          }
          ,
          {
               title: "Kids' Clothing",
               icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZo2k_dbJ22_eNBTVL1wpxEis4KkLnqyWofcIcgw1YTeGrCcEw0Zi4QhG_jBSA3t-lfKc&usqp=CAU",
               subMenu: ["Kids Tshirt", "Kids Shorts"]
          }
          ,
          {
               title: "Kids' Clothing",
               icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZo2k_dbJ22_eNBTVL1wpxEis4KkLnqyWofcIcgw1YTeGrCcEw0Zi4QhG_jBSA3t-lfKc&usqp=CAU",
               subMenu: ["Kids Tshirt", "Kids Shorts"]
          }
          ,
          {
               title: "Kids' Clothing",
               icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZo2k_dbJ22_eNBTVL1wpxEis4KkLnqyWofcIcgw1YTeGrCcEw0Zi4QhG_jBSA3t-lfKc&usqp=CAU",
               subMenu: ["Kids Tshirt", "Kids Shorts"]
          }
          ,
          {
               title: "Kids' Clothing",
               icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZo2k_dbJ22_eNBTVL1wpxEis4KkLnqyWofcIcgw1YTeGrCcEw0Zi4QhG_jBSA3t-lfKc&usqp=CAU",
               subMenu: ["Kids Tshirt", "Kids Shorts"]
          }
          ,
          {
               title: "Kids' Clothing",
               icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZo2k_dbJ22_eNBTVL1wpxEis4KkLnqyWofcIcgw1YTeGrCcEw0Zi4QhG_jBSA3t-lfKc&usqp=CAU",
               subMenu: ["Kids Tshirt", "Kids Shorts"]
          }
          ,
          {
               title: "Kids' Clothing",
               icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZo2k_dbJ22_eNBTVL1wpxEis4KkLnqyWofcIcgw1YTeGrCcEw0Zi4QhG_jBSA3t-lfKc&usqp=CAU",
               subMenu: ["Kids Tshirt", "Kids Shorts"]
          }
          ,
          {
               title: "Kids' Clothing",
               icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZo2k_dbJ22_eNBTVL1wpxEis4KkLnqyWofcIcgw1YTeGrCcEw0Zi4QhG_jBSA3t-lfKc&usqp=CAU",
               subMenu: ["Kids Tshirt", "Kids Shorts"]
          }
          ,
          {
               title: "Kids' Clothing",
               icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZo2k_dbJ22_eNBTVL1wpxEis4KkLnqyWofcIcgw1YTeGrCcEw0Zi4QhG_jBSA3t-lfKc&usqp=CAU",
               subMenu: ["Kids Tshirt", "Kids Shorts"]
          }
          ,
          {
               title: "Kids' Clothing",
               icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZo2k_dbJ22_eNBTVL1wpxEis4KkLnqyWofcIcgw1YTeGrCcEw0Zi4QhG_jBSA3t-lfKc&usqp=CAU",
               subMenu: ["Kids Tshirt", "Kids Shorts"]
          }
          ,
          {
               title: "Kids' Clothing",
               icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZo2k_dbJ22_eNBTVL1wpxEis4KkLnqyWofcIcgw1YTeGrCcEw0Zi4QhG_jBSA3t-lfKc&usqp=CAU",
               subMenu: ["Kids Tshirt", "Kids Shorts"]
          }
     ];

     // মেনু সিলেক্ট করার জন্য handleAccordion ক্লিক হ্যান্ডলার
     handleAccordion = (index) => {
          this.setState({
               activeIndex: this.state.activeIndex === index ? null : index
          });
     }

     render() {
          return (
               <div className="accordionMenuDivMobile">
                    <div className="accordionMenuDivInsideMobile">
                         {this.menuData.map((menu, index) => (
                              <div key={index}>
                                   <button 
                                        className={`accordionMobile ${this.state.activeIndex === index ? 'active' : ''}`} 
                                        onClick={() => this.handleAccordion(index)}>
                                        <img className="accordionMenuIconMobile" 
                                             src={menu.icon} 
                                             alt="Menu Icon" 
                                        /> &nbsp; {menu.title}
                                   </button>
                                   <div 
                                        className="panelMobile" 
                                        style={{ 
                                             maxHeight: this.state.activeIndex === index ? '100px' : '0px',
                                             overflow: 'hidden',
                                             transition: 'max-height 0.3s ease-out'
                                        }}>
                                        <ul>
                                             {menu.subMenu.map((item, idx) => (
                                                  <li key={idx}>
                                                       <a href="#" className="accordionItemMobile">{item}</a>
                                                  </li>
                                             ))}
                                        </ul>
                                   </div>
                              </div>
                         ))}
                    </div>
               </div>
          );
     }
}

export default MegaMenuMobile;
